export default __webpack_public_path__ + "static/media/beep.51341277.mp3";